<script>
  import { slide } from 'svelte/transition';
  import { quintOut } from 'svelte/easing';
  export let headerText = "";
  export let headerStyle = "";
  export let strokeStyle = "";
  export let ridersInCategory;
  let expanded = false;
</script>

<div class="my-0 py-0">
  <h4 class="my-0">
    <button style="{headerStyle}" aria-expanded={expanded} on:click={() => expanded = !expanded}>
      <!-- <div class="container">
        <div class="row">
          <span class="col-10 text-start p-0">{headerText}</span>
          {#if ridersInCategory}
            <span class="col-2 text-danger">{ridersInCategory}</span>
          {/if}
        </div>
      </div> -->
      
          <div class="text-start p-0">{headerText}
          {#if ridersInCategory}
            <span class="text-danger text-start">{ridersInCategory}</span>
          {/if}
          </div>
      <div style="margin-left:10px;">
        <svg viewBox="0 0 20 20" fill="none">
          <path class="vert" d="M10 1V19" stroke="{strokeStyle}" stroke-width="4"/>
          <path d="M1 10L19 10" stroke="{strokeStyle}" stroke-width="4"/>
        </svg>
      </div>
    </button>
  </h4>
    
  <div class='contents my-0 py-0' hidden={!expanded}>
    {#if expanded}
      <!--<p transition:slide="{{delay: 250, duration: 300, easing: quintOut }}">-->
      <div>
        <slot></slot>
      </div>
    {/if}
  </div>
</div>



<style>	
  button {
    background-color: var(--background, rgb(141, 135, 135));
    color: var(--gray-darkest, #e9e0e0);
    display: flex;
		justify-content: space-between;
    width: 100%;
		border: none;
		margin: 0;
		padding: 1em 0.75em;
    text-transform: uppercase;
    font-weight: 700;
  }

  button[aria-expanded="true"] {
    border-bottom: 1px solid var(--gray-light, #eee);
  }

    button[aria-expanded="true"] .vert {
        display: none;
    }

    button:focus svg{
        outline: 2px solid;
    }

    button [aria-expanded="true"] rect {
        fill: currentColor;
    }

    svg {
        height: 0.7em;
				width: 0.7em;
    }
</style>